export default __webpack_public_path__ + "static/media/soccer3.52807b3a.PNG";